import { useState } from "react";

/** Bản ghi tài khoản đăng nhập lưu ở localStorage "user" (hỏng / chưa có thì trả object rỗng) */
export function readStoredUser(): any {
    try {
        return JSON.parse(localStorage.getItem("user") || "{}") || {};
    } catch {
        return {};
    }
}

/**
 * Tài khoản đăng nhập, đọc một lần khi component mount thay vì parse localStorage mỗi lần render
 * (vd khung chat render lại theo từng phím gõ). Đổi tài khoản là đăng nhập lại -> trang tải lại.
 */
export default function useStoredUser(): any {
    const [user] = useState(readStoredUser);
    return user;
}
